import { Delete as DeleteIcon } from "@mui/icons-material";
import { Grid, IconButton } from "@mui/material";
import type { FC, ReactNode } from "react";
import NumberField from "../../components/numberField/NumberField";
import { Select } from "../../components/select/Select";
import type { SelectedProductOption } from "./SelectedProductOption";

const DeleteOptionButton: FC<{ onDelete: () => void }> = ({ onDelete }) => (
  <IconButton color="secondary" onClick={onDelete} aria-label="Usuń opcję">
    <DeleteIcon />
  </IconButton>
);

interface Option {
  value: string;
  label: string;
  tooltip?: string;
}

interface Props {
  readonly options: Option[];
  readonly value: SelectedProductOption;
  readonly readonly: boolean;
  readonly hintText?: ReactNode;
  readonly onHintDoubleClick?: () => void;
  readonly onChange: (value: SelectedProductOption) => void;
  readonly onDelete: () => void;
}

const ProductOption: FC<Props> = ({ value, options, readonly, hintText, onHintDoubleClick, onChange, onDelete }) => (
  <>
    <Grid size={readonly ? 9 : 7}>
      <Select
        label="Opcja"
        helperText={hintText}
        onHelperDoubleClick={onHintDoubleClick}
        size="small"
        fullWidth
        readonly={readonly}
        values={options}
        value={value.id ?? ""}
        onSelect={(id) => onChange({ id, quantity: value.quantity })}
      />
    </Grid>
    <Grid size={3}>
      <NumberField
        label="Ilość"
        size="small"
        fullWidth
        minWidth={50}
        readonly={readonly}
        value={value.quantity}
        onChange={(quantity) =>
          onChange({
            id: value.id,
            quantity: quantity ?? 0,
          })
        }
      />
    </Grid>
    {!readonly && (
      <Grid size={2}>
        <DeleteOptionButton onDelete={onDelete} />
      </Grid>
    )}
  </>
);

export default ProductOption;
